const benefits = [
  {
    icon: 'ri-rocket-line',
    title: 'First to Know About New Services',
    desc: 'Be among the first to hear when we launch new AI automation services, so you can get ahead of competitors before anyone else.',
    color: 'from-ea-blue/20 to-ea-blue/5',
  },
  {
    icon: 'ri-tools-line',
    title: 'New Tools & Feature Updates',
    desc: 'Get notified the moment we add new tools, integrations, or improvements to our automation platform, with no delays and straight to your inbox.',
    color: 'from-ea-blue/20 to-ea-blue/5',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Business Automation Insights',
    desc: 'Receive practical tips, case studies, and strategic insights to help you automate smarter and grow your business faster.',
    color: 'from-ea-blue/20 to-ea-blue/5',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Exclusive Offers & Launches',
    desc: 'Members receive early access to new service launches and exclusive offers not available to the general public.',
    color: 'from-ea-blue/20 to-ea-blue/5',
  },
  {
    icon: 'ri-newspaper-line',
    title: 'Everything Automation News',
    desc: 'Stay connected with company updates, partnership announcements, and everything happening behind the scenes.',
    color: 'from-ea-blue/20 to-ea-blue/5',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Priority Support Access',
    desc: 'Members get priority responses from our team and early access to our client portal when it launches.',
    color: 'from-ea-blue/20 to-ea-blue/5',
  },
];

const SignupBenefits = () => {
  return (
    <section className="bg-ea-navy py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-ea-blue/10 border border-ea-blue/30 mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-ea-blue"></span>
            <span className="text-ea-blue text-xs font-medium uppercase tracking-wider">Why Join?</span>
          </div>
          <h2 className="text-4xl font-bold text-white mb-4">
            Everything You Get as a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-ea-blue to-ea-blue-electric">
              Member
            </span>
          </h2>
          <p className="text-ea-gray text-lg max-w-xl mx-auto">
            Creating an account is free. Here's why 800+ business owners have already signed up.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {benefits.map((b, i) => (
            <div
              key={b.title}
              className="bg-ea-dark-card border border-ea-dark-border hover:border-ea-blue/40 rounded-xl p-4 sm:p-7 group transition-all duration-300 cursor-default relative overflow-hidden"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${b.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
              <div className="relative z-10">
                <div className="w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center rounded-xl bg-ea-blue/10 border border-ea-blue/20 group-hover:bg-ea-blue/20 transition-colors duration-300 mb-3 sm:mb-5">
                  <i className={`${b.icon} text-ea-blue text-base sm:text-xl`}></i>
                </div>
                <div className="absolute top-4 right-4 sm:top-7 sm:right-7 w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center rounded-full bg-ea-black/40 border border-ea-dark-border">
                  <span className="text-ea-gray/50 text-[10px] font-bold">0{i + 1}</span>
                </div>
                <h3 className="text-white font-semibold text-xs sm:text-base mb-2 sm:mb-3 leading-snug">{b.title}</h3>
                <p className="text-ea-gray text-xs leading-relaxed hidden sm:block">{b.desc}</p>
                <p className="text-ea-gray/80 text-[11px] leading-relaxed sm:hidden line-clamp-3">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SignupBenefits;
